<template>
  <div>
    <alert-modal
      :title="alertModal.title"
      :body="alertModal.body"
      :active="alertModal.active"
      :actions="alertModal.actions"
      :dismiss="alertModal.dismiss"
      @action="alertModal.done"></alert-modal>
    <new-document-modal
      v-if="newDocumentModal.active"
      :class="{ 'is-active': newDocumentModal.active }"
      :options="newDocumentModal.options"></new-document-modal>
    <new-contact-modal
      v-if="newContactModal.active"
      :class="{ 'is-active': newContactModal.active }"
      :options="newContactModal.options"></new-contact-modal>
    <edit-contact-modal
      v-if="editContactModal.active"
      :class="{ 'is-active' : editContactModal.active }"
      :options="editContactModal.options"></edit-contact-modal>
    <integrations-modal
      v-if="integrationsModal.active"
      :class="{ 'is-active': integrationsModal.active }"
      :options="integrationsModal.options"></integrations-modal>
    <share-modal
      v-if="shareModal.active"
      :class="{ 'is-active': shareModal.active }"
      :options="shareModal.options"></share-modal>
    <whats-new-modal
      v-if="whatsNewModal.active"
      :class="{ 'is-active': whatsNewModal.active }"
      :options="whatsNewModal.options"></whats-new-modal>
    <notifications-modal
      v-if="notificationsModal.active"
      :class="{ 'is-active': notificationsModal.active }"
      :options="notificationsModal.options"></notifications-modal>
    <support-form-modal
      v-if="supportFormModal.active"
      :class="{ 'is-active': supportFormModal.active }"
      :options="supportFormModal.options"></support-form-modal>
    <saved-messages-modal
      v-if="savedMessagesModal.active"
      :class="{ 'is-active': savedMessagesModal.active }"
      :options="savedMessagesModal.options"></saved-messages-modal>
  </div>
</template>

<script>
import AlertModal from './alert-modal.vue';
import NewDocumentModal from './new-document-modal.vue';
import NewContactModal from './new-contact-modal.vue';
import EditContactModal from './edit-contact-modal.vue';
import IntegrationsModal from './integrations-modal.vue';
import ShareModal from './share-modal.vue';
import WhatsNewModal from './whats-new-modal.vue';
import NotificationsModal from './notifications-modal.vue';
import SupportFormModal from './support-form-modal.vue';
import SavedMessagesModal from './saved-messages-modal.vue';

export default {
  components: {
    AlertModal,
    NewDocumentModal,
    NewContactModal,
    EditContactModal,
    IntegrationsModal,
    ShareModal,
    WhatsNewModal,
    NotificationsModal,
    SupportFormModal,
    SavedMessagesModal,
  },
  data() {
    return {
      Events: window.Events,
      alertModal: {
          active: false,
          title: '',
          body: '',
          actions: [],
          done: function() {
          }
      },
      integrationsModal: {
        active: false,
        options: {}
      },
      whatsNewModal: {
        active: false,
        options: {}
      },
      shareModal: {
        active: false,
        options: {}
      },
      newDocumentModal: {
        active: false,
        options: {}
      },
      newContactModal: {
        active: false,
        options: {}
      },
      editContactModal: {
        active: false,
        options: {}
      },
      notificationsModal: {
        active: false,
        options: {}
      },
      supportFormModal: {
        active: false,
        options: {}
      },
      savedMessagesModal: {
        active: false,
        options: {}
      }
    }
  },
  mounted() {
    /* GENERIC MODAL COMMANDS */
    this.Events.$on('modalOpen', (modal, options) => {
      if (this[modal]) {
        this[modal].active = true;
        this[modal].options = options;
        this.Events.$emit('blurApp', true);
      }
    });
    this.Events.$on('modalClose', (modal) => {
      if (this[modal]) {
        this[modal].active = false;
        this[modal].options = {};
        this.Events.$emit('blurApp', false);
      }
    });

    /* GLOBAL ALERT MODAL */
    this.Events.$on('alertModal', (options) => {
      this.$set(this.alertModal, 'title', options.title);
      this.$set(this.alertModal, 'body', options.body);
      this.$set(this.alertModal, 'actions', options.actions);
      this.$set(this.alertModal, 'done', options.done);
      this.$set(this.alertModal, 'dismiss', options.dismiss);
      this.$set(this.alertModal, 'active', true);
      this.Events.$emit('blurApp', true);
    });

    this.Events.$on('closeAlertModal', () => {
      this.$set(this.alertModal, 'active', false);
      this.Events.$emit('blurApp', false);
    });

    this.Events.$on('alertModalDone', (value) => {
      this.$set(this.alertModal, 'active', false);
      this.Events.$emit('blurApp', false);

      if (_.isFunction(this.alertModal.done)) {
        this.alertModal.done(value);
      }
    });

    this.Events.$on('closeAnalyticsModal', () => {
      this.$set(this.documentAnalyticsModal, 'active', false);
    });
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// parent-modal-container.vue?6136b980